var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 7.88625V8.49958C14.6659 9.9372 14.2003 11.336 13.3396 12.4875C12.4788 13.6389 11.2689 14.4812 9.89025 14.8889C8.51163 15.2965 7.03818 15.2475 5.68966 14.7493C4.34113 14.2511 3.18978 13.3303 2.40732 12.1243C1.62485 10.9183 1.2532 9.49163 1.34779 8.05713C1.44239 6.62263 1.99815 5.25713 2.9322 4.1643C3.86625 3.07146 5.12853 2.30984 6.5308 1.99301C7.93307 1.67619 9.40019 1.82114 10.7133 2.40625M14.6667 3.16625L8.00001 9.83958L6.00001 7.83958",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/CheckCircle.964ee6c994998122d45d6fc8f000d5a9.svg";
export { ForwardRef as ReactComponent };